import Policies from './Policies';
import Articles from "./Articles";
import Tweets from "./Tweets";
import Countries from "./Countries";
import Metrics from "./Metrics";
import World from "./World";

export default class Store {

    constructor(state = {}, worldId) {
        this.policies = new Policies(state, worldId);
        this.articles = new Articles(state, worldId);
        this.tweets = new Tweets(state, worldId);
        this.countries = new Countries(state, worldId);
        this.metrics = new Metrics(state);
        this.world = new World(state, worldId);
    }
}
